module.exports = __webpack_public_path__ + "img/bg33.dde24d32.jpg";